import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArchitectureIcon(props: IconProps) {
    return <Icon {...props} iconKey={"architecture"}/>
}
